import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/cookie-policy/client/CookiePolicyClient.tsx");
